// extracted by mini-css-extract-plugin
export default {"title":"style_title__am4l3","categoryItem":"style_categoryItem__EkNuY","imgBlock":"style_imgBlock__8BQ+X","activeCategory":"style_activeCategory__sG3CO"};